import React from 'react';
import Field from '../Field/Field';
import Multiselect from '../Field/Multiselect';
import { FieldInputType, FieldType, OperatorType } from '../_types';
import { debounce } from '../_utils';
import './TableFilterRow.css';
var TableFilterRow = function (props) {
    var _a = props.fields, fields = _a === void 0 ? [] : _a, filters = props.filters, selectMode = props.selectMode, actions = props.actions, onFetchItems = props.onFetchItems, onFilter = props.onFilter;
    var getColumnFilters = function () {
        if (!filters)
            return {};
        var b = fields.reduce(function (a, field) {
            var _a;
            if (((_a = field === null || field === void 0 ? void 0 : field.type) === null || _a === void 0 ? void 0 : _a.substring(0, 4)) === FieldType.Date) {
                setFilter(a, field, OperatorType.GreaterOrEqual, filters);
                setFilter(a, field, OperatorType.LessOrEqual, filters);
            }
            else if (field.type === FieldType.Select ||
                field.type === FieldType.Checkbox) {
                setFilter(a, field, OperatorType.Equal, filters);
            }
            else {
                setFilter(a, field, '', filters);
            }
            return a;
        }, {});
        return b;
    };
    var getSelectedOptions = function (field) {
        var _a;
        var filter = (_a = getColumnFilters()) === null || _a === void 0 ? void 0 : _a[field.name + "_" + OperatorType.Equal];
        var values;
        if (Array.isArray(filter)) {
            values = filter.map(function (value) {
                var _a;
                return (_a = field === null || field === void 0 ? void 0 : field.options) === null || _a === void 0 ? void 0 : _a.find(function (field) {
                    return field.value === (value.value ? value.value : value);
                });
            });
        }
        else {
            values = field.options.find(function (field) {
                return field.value === (filter.value ? filter.value : filter);
            });
        }
        if (values) {
            return values;
        }
        return { text: '' };
    };
    var removeFilter = function (field, operator) {
        return filterBy(null, field, operator);
    };
    var debounceFilter = debounce(function (e, field) {
        filterBy(e, field);
    }, 200);
    var filterBy = function (e, field, operator, value, hasFocus) {
        if (hasFocus === void 0) { hasFocus = false; }
        if (field.multifilter) {
            value = [e.value ? e.value : e];
            if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
                value = [];
            }
        }
        var _value;
        if (value || value === false) {
            _value = value;
        }
        else {
            if (e && e.target && (e.target.value || e.target.value === '')) {
                _value = e.target.value;
            }
            else if (e && (e.value || e.value === false)) {
                _value = e.value;
            }
            else {
                _value = e;
            }
        }
        var filter = {
            field: field.name,
            value: _value,
            operator: '',
            hasFocus: false
        };
        if (operator) {
            filter.operator = operator;
        }
        if (hasFocus) {
            filter.hasFocus = hasFocus;
        }
        if (onFilter) {
            onFilter(filter);
        }
        onFetchItems && onFetchItems({ filter: filter });
    };
    var setFilter = function (a, field, operator, filters) {
        if (!field || !field.name) {
            return;
        }
        var key = operator ? field.name + "_" + operator : field.name;
        var filter = filters.find(function (f) {
            return (field.name === f.field && (!operator || f.operator === operator));
        });
        a[key] =
            filter && filter.value ? filter.value : field.multifilter ? [] : '';
    };
    var canEditFieldFilter = function (field, filter) {
        return (filter == null ||
            filter.value.length === 0 ||
            field.filterDebounce !== null ||
            filter.hasFocus === true);
    };
    var getFilter = function (field) {
        return filters && filters.find(function (f) { return (f === null || f === void 0 ? void 0 : f.field) === field.name; });
    };
    var getCheckboxOptions = function (field) {
        return [true, false].map(function (b) {
            return {
                value: b,
                text: (field === null || field === void 0 ? void 0 : field.formatter) ? field.formatter(b) : b ? 'Yes' : 'No'
            };
        });
    };
    var getFilterValue = function (field, operator) {
        var _a;
        return (_a = columnFilters) === null || _a === void 0 ? void 0 : _a[field + "_" + operator];
    };
    var columnFilters = getColumnFilters();
    return (React.createElement("tr", { key: "filter", className: "filter-row" }, fields === null || fields === void 0 ? void 0 :
        fields.map(function (field, index) {
            var _a, _b, _c, _d;
            var _e, _f;
            var filter = getFilter(field);
            var filterValue = filter ? filter.value : '';
            var canEditField = canEditFieldFilter(field, filter);
            return (React.createElement("td", { key: index }, (field === null || field === void 0 ? void 0 : field.filter) !== false && field.type ? (React.createElement(React.Fragment, null,
                (field.type === FieldType.Input ||
                    field.type === FieldType.Textarea ||
                    field.type === FieldType.Search ||
                    field.type === FieldInputType.Email) && (React.createElement(React.Fragment, null,
                    canEditField && (React.createElement("input", { className: "form-control", placeholder: field === null || field === void 0 ? void 0 : field.filterHelp, value: filterValue, onInput: function (e) {
                            return field.filterDebounce
                                ? debounceFilter(e, field)
                                : null;
                        }, onChange: function (e) {
                            return field.filterDebounce
                                ? null
                                : filterBy(e, field, undefined, null, true);
                        } })),
                    !canEditField && (React.createElement("div", { className: "form-control d-flex align-items-center justify-content-between" },
                        React.createElement("span", { className: "text-nowrap" },
                            filterValue,
                            "\u00A0"),
                        React.createElement("div", { className: "input-clear fas fa-times-circle", onClick: function () {
                                return removeFilter(field);
                            } }))))),
                field.type === FieldType.Select &&
                    !field.multifilter && (React.createElement(Field, { value: (_a = {},
                        _a[(_e = field) === null || _e === void 0 ? void 0 : _e.name] = getFilterValue(field.name, OperatorType.Equal),
                        _a), field: {
                        name: field === null || field === void 0 ? void 0 : field.name,
                        type: FieldType.Select,
                        options: field.options
                    }, onChange: function (e) {
                        return filterBy(e, field, OperatorType.Equal);
                    } })),
                field.type === FieldType.Select &&
                    field.multifilter && (React.createElement(Multiselect, { options: field.options, selectedOptions: getSelectedOptions(field), onSelect: function (e) {
                        return filterBy(e, field, OperatorType.Equal);
                    } })),
                field.type === FieldType.Checkbox && (React.createElement(Field, { value: (_b = {},
                        _b[(_f = field) === null || _f === void 0 ? void 0 : _f.name] = getFilterValue(field.name, OperatorType.Equal) === ''
                            ? null
                            : getFilterValue(field.name, OperatorType.Equal) === 'true'
                                ? true
                                : false,
                        _b), field: {
                        name: field === null || field === void 0 ? void 0 : field.name,
                        type: FieldType.Radio,
                        options: getCheckboxOptions(field)
                    }, onChange: function (e) {
                        return filterBy(e, field, OperatorType.Equal);
                    } })),
                field.type.substring(0, 4) ===
                    FieldType.Date && (React.createElement(React.Fragment, null,
                    React.createElement(Field, { value: (_c = {},
                            _c[field.name + "-from"] = getFilterValue(field.name, OperatorType.GreaterOrEqual),
                            _c), field: {
                            name: field.name + "-from",
                            type: FieldType.Date
                        }, onChange: function (e) {
                            return filterBy(e, field, OperatorType.GreaterOrEqual);
                        } }),
                    React.createElement(Field, { value: (_d = {},
                            _d[field.name + "-to"] = getFilterValue(field.name, OperatorType.LessOrEqual),
                            _d), field: {
                            name: field.name + "-to",
                            type: FieldType.Date
                        }, onChange: function (e) {
                            return filterBy(e, field, OperatorType.LessOrEqual);
                        } }))))) : (React.createElement("span", null, "\u00A0"))));
        }),
        selectMode && React.createElement("td", null),
        actions && React.createElement("td", { className: "column-actions" })));
};
export default TableFilterRow;
